export class Field {
    id: any; //GET response key
    title: string;
    options?: any[];
    countable?: boolean = false;
    key?: any; //filter value
    type?: string; //future use to support more types than multicheckbox
    initVal?: any; //initial state of filter
    // disable?: boolean=false;
    disableEmitter?: any;
    counterEmmiter?: any;
    sort?: any;  //Sort filter fields by sortType/custom function
    minOnly?: number; //Show select all checkbox if number of options > minOnly
    cutOffLower?: number; // Show <cutOffLower> in 'less' view if number of options > <cutOffUpper>
    cutOffUpper?: number;
    level?: number; // Support for hierarchical filtering
    updateEditFields?: (a: any[], b: Field) => void;
    formatter?: (item:string) => string;

    constructor({ id, title, options = null, countable = false, key = '', type = null, initVal = true, disableEmitter = null, counterEmmiter = null,
        sort = sortType.ALPHABETICALLY, level = 0, formatter = (item) => {return item},
        minOnly = 2, cutOffLower = 3, cutOffUpper = 0, updateEditFields = (array: any[], deliveryFormat: any) => {
            deliveryFormat.options = [];
            let deliverySet = new Map<string, number>();
            array.forEach(it => { deliverySet.set(getValue(it, deliveryFormat), (deliverySet.get(getValue(it, deliveryFormat)) || 0) + 1) });
            deliverySet.forEach((value, key, map) =>
                deliveryFormat.options.push({
                    key, checked: deliveryFormat.hasOwnProperty('initVal') ? deliveryFormat.initVal : true,
                    countable: !!deliveryFormat.countable, value: key, counter: value
                }));
        } }) {
        this.id = id;
        this.title = title;
        this.options = options;
        this.countable = !!countable;
        this.key = key === '' ? id : key;
        this.type = type;
        this.initVal = initVal;
        this.disableEmitter = disableEmitter;
        this.counterEmmiter = counterEmmiter;
        this.sort = sort;
        this.minOnly = minOnly;
        this.cutOffLower = cutOffLower;
        this.cutOffUpper = cutOffUpper > 0 ? cutOffUpper : 2 * cutOffLower;
        this.updateEditFields = updateEditFields;
        this.level = level;
        this.formatter = formatter;
    }
}
function getValue(item: any, field: any) {
    if (field.config && field.config.type === 'composite') {
        return field.config.format(item);
    }

    let id = field.id;
    let value = null;

    if (typeof id == 'function') {
        value = id(item);
    } else {
        if (id.split('.').length > 1) {
            let props = id.split('.');
            value = item;
            for (let v of props) {
                if (value[v])
                    value = value[v];
                else {
                    value = null;
                    break;
                }
            }
        } else {
            value = item[id];
        }
    }

    return value;
}
export enum sortType { ALPHABETICALLY, POPULAR };



// WEBPACK FOOTER //
// ./src/app/solar/common/field.ts